import { useQueryClient } from "react-query";
import { useTranslation } from "react-i18next";
import { RemoteApiError } from "../useRemote/types";
import { useRemoteMutation } from "../useRemote/useRemoteMutation";
import { VehicleBlockingEvent } from "../../../components/FleetManagement/types/FleetManagement.types";

export type UpdateBlockingEventPayload = {
  blockingEventId: number;
  start?: string;
  end?: string;
  reason?: string | null;
  vehicleId?: number;
};

/**
 * Updates a blocking event (PATCH /fleet/blocking-events/:id).
 * Use mutateAsyncSafe when calling from UI so errors are handled in the hook and the promise never rejects.
 */
export function useRemoteUpdateBlockingEvent() {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  return useRemoteMutation<VehicleBlockingEvent, RemoteApiError, UpdateBlockingEventPayload>({
    key: ["fleet", "update-blocking-event"],
    url: payload => `/fleet/blocking-events/${payload.blockingEventId}`,
    method: "patch",
    body: ({ start, end, reason, vehicleId }) => ({
      start,
      end,
      reason,
      ...(vehicleId != null ? { vehicleInventoryId: vehicleId } : {})
    }),
    snackbarTextOnSuccess: t("Blocking event updated"),
    onSuccess: () => {
      queryClient.invalidateQueries(["fleet", "vehicles"]);
      queryClient.invalidateQueries(["fleet", "blocking-events"]);
    }
  });
}
